import React from "react";
import { Route, Routes } from "react-router-dom";

import Renew from "@/components/screens/Renew";
import { RENEW_MESSAGES } from "@/messages/renew/renew.messages";

const RenewPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:salesproductpriceId/:lang" element={<Renew messages={RENEW_MESSAGES} />} />
      <Route path="/" element={<Renew messages={RENEW_MESSAGES} />} />
    </Routes>
  );
};

export default RenewPage;
